import { httpResource } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { GroupDto, GroupHasAnySale } from '@shared/types/dto/group/group.dto';
import { resourceTrigger } from '@shared/utils/resourceTrigger';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { WorkspaceService } from './workspace.service';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  userService = inject(UserService);
  workspaceService = inject(WorkspaceService);
  constructor() {


  }

  readonly allAvailableWithWorkspace = resourceTrigger<GroupDto[]>(() => {
    const user = this.userService.user.value();
    if (!user) return undefined;
    this.workspaceService.workspaceChanged(); // atualiza quando o workspace muda
    return `${environment.API_HOST}/group/allAvailable`;
  }, { defaultValue: undefined });

  readonly currentGroupId = computed(() => {
    return this.workspaceService.currentWorkspace.value()?.group.id;
  })

  readonly currentGroupHasAnySale = httpResource<GroupHasAnySale>(() => {
    const groupId = this.currentGroupId();
    const user = this.userService.user.value(); // Garantia de reatividade ao usuário
    if (!groupId) return undefined;
    return `${environment.API_HOST}/group/${groupId}/hasAnySale`;
  })

}


